import React from 'react';
import { withRouter } from "react-router";
import { API } from "aws-amplify";
import { toast } from "react-toastify";
import _ from "lodash";

import Modal from "@/common/Modal";

import CreateAgent from "./CreateAgent";

function highlightMatch(text, query) {
    if (!query.trim() || !text) return text;
    const idx = text.toLowerCase().indexOf(query.trim().toLowerCase());
    if (idx === -1) return text;
    return (
        <>
            {text.slice(0, idx)}
            <mark style={{
                background: 'var(--colorSearchHighlightBg)',
                color: 'var(--colorSearchHighlightText)',
                padding: '0 1px',
                borderRadius: '2px',
            }}>
                {text.slice(idx, idx + query.trim().length)}
            </mark>
            {text.slice(idx + query.trim().length)}
        </>
    );
}

function SupportToolsAgents({ searchInput = '', countRef, ...props }) {
    const [agents, setAgents] = React.useState([]);
    const [createOpen, setCreateOpen] = React.useState(false);

    const simpleMode = window.__RUNTIME_CONFIG__?.AGENTS_SIMPLE_MODE === 'true';

    const loadAgents = () => {
        const endpoint = simpleMode ? '/api/v1/agents' : '/api/v1/agents/with-connectors';
        API.get('Core', endpoint)
            .then(response => {
                setAgents(Object.assign([], response));
            },
                error => {
                    toast("Could not load agents: " + error.response.data.message, { position: "top-center", type: "error" });
                }
            );
    }

    React.useEffect(() => {
        loadAgents();
    }, []);

    const onAgentCreateSuccess = () => {
        loadAgents();
        setCreateOpen(false);
    }

    const q = searchInput.trim().toLowerCase();
    const visibleAgents = _.sortBy(
        agents.filter(agent =>
            q === '' ||
            agent.name?.toLowerCase().includes(q) ||
            (!simpleMode && agent.connectors?.some(c => c.datasourceName?.toLowerCase().includes(q)))
        ),
        'name'
    );

    if (countRef) countRef.current = visibleAgents.length;

    return (
        <div className="scrollView">

            <div className="">
                <Modal
                    button={(
                        <div
                            className="addButton"
                            tabIndex={0}
                            role="button"
                            aria-label="Create Agent"
                            onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); setCreateOpen(true); } }}
                        >
                            <div className="buttonIcon" aria-hidden="true" />
                            <div className="buttonTitle">Create Agent</div>
                        </div>
                    )}
                    content={(<CreateAgent onSuccess={onAgentCreateSuccess} />)}
                    title="Create Agent"
                    size="large"
                    handleClose={() => setCreateOpen(false)}
                    handleOpen={() => setCreateOpen(true)}
                    open={createOpen}
                />

            </div>

            <div className="surveysList tableView">
                <div className="tableSection">
                    {
                        visibleAgents.map(function (agent) {
                            const displayName = agent.name?.length > 30 ? agent.name.substring(0, 30) + '...' : agent.name;
                            return (
                                <div key={agent.id} className="tableCell tenantCell">
                                    <div className="cellBody">
                                        <div className="title">{highlightMatch(displayName, searchInput)}</div>
                                        <div className="subtitle" style={{ color: 'var(--colorTitle)', opacity: 1 }}>Token: <b>{agent.token}</b></div>
                                        {!simpleMode && q !== '' && agent.connectors?.some(c => c.datasourceName?.toLowerCase().includes(q)) && (() => {
                                            const matched = agent.connectors.filter(c => c.datasourceName?.toLowerCase().includes(q));
                                            const visible = matched.slice(0, 2);
                                            const overflow = matched.length - visible.length;
                                            return (
                                                <div className="subtitle" aria-label="Matching connectors" style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center', overflow: 'hidden', color: 'var(--colorTitle)', opacity: 1 }}>
                                                    {visible.map((c, i) => (
                                                        <span key={i} style={{ marginRight: 6, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: 120, color: 'var(--colorTitle)' }}>
                                                            {highlightMatch(c.datasourceName, searchInput)}
                                                        </span>
                                                    ))}
                                                    {overflow > 0 && (
                                                        <span style={{ whiteSpace: 'nowrap', flexShrink: 0, color: 'var(--colorTitle)' }}>
                                                            +{overflow} more
                                                        </span>
                                                    )}
                                                </div>
                                            );
                                        })()}
                                    </div>

                                    <div
                                        onClick={() => { props.history.push('/support-tools/agent/' + agent.id); }}
                                        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); props.history.push('/support-tools/agent/' + agent.id); } }}
                                        className="button small action"
                                        role="button"
                                        tabIndex={0}
                                        aria-label={`Manage ${agent.name}`}
                                    >
                                        <div className="buttonTitle">Manage</div>
                                    </div>
                                </div>
                            )
                        })
                    }
                    {visibleAgents.length === 0 && searchInput.trim() !== '' && (
                        <div className="emptyState">
                            {simpleMode ? 'No agents match your search.' : 'No agents or connectors match your search.'}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default withRouter(SupportToolsAgents);